var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',_vm._g(_vm._b({staticClass:"job-status font-weight-bold",attrs:{"label":"","text-color":_vm.status.textColor,"color":_vm.status.color},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._v(_vm._s(_vm.status.text))]},proxy:true}])},'v-chip',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }